<template>
    <footer />
</template>

<script>
export default {
    name: 'component-footer'
}
</script>

<style scoped>

</style>